var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parallax__wrapper",style:(`--height: ${_vm.preparedHeight}; --width: ${_vm.preparedWidth}`)},[_c('div',{ref:"parallaxBg",staticClass:"parallax__image",style:(`--size: ${_vm.size}%; background-image: url(${_vm.src})`)}),_c('div',{staticClass:"parallax__inner-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }